import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
// redux actions
import {
	SAVE_OPTION,
	UPDATE_OPTION,
	GET_OPTIONS,
	OPTION_RESET_ALL,
	OPTION_CLEAR_ERROR,
} from './actionTypes';
import {
	setOptions,
	optionError,
	optionResetAll,
	optionClearError,
	insertOption,
} from './actions';
// Api methods
import { api } from 'api';
// interface
import { AxiosResponse } from 'axios';
import { Option, SaveRes, SaveStatus } from 'api';
import { mapOptionsApiToStore, mapOptionApiToStore } from '../../utils/mappers';
import { apiLoading, apiResError, apiResSuccess } from '../actions';

// interface IOptionPayload {
//     payload?: string|number,
//     type: string
// }

export interface IOptionSavePayload {
	payload: Option;
	type: string;
}

function* getOptions() {
	try {
		const response: AxiosResponse<Option[]> =
			yield api.option.apiOptionDataGet();
		const options = mapOptionsApiToStore(response.data);

		yield put(setOptions(options));
	} catch (error: any) {
		yield put(optionError(error.message));
	}
}

function* getOptionById(id: number) {
	try {
		const response: AxiosResponse<Option> =
			yield api.option.apiOptionDataIdGet(id);
		const option = mapOptionApiToStore(response.data);

		yield put(insertOption(option));
	} catch (error: any) {
		yield put(optionError(error.message));
	}
}

function* saveOption({ payload }: IOptionSavePayload) {
	yield put(apiLoading());
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.option.apiOptionDataPost(payload);

		if (response.data.status === SaveStatus.Success) {
			const id = response.data.createdId || 0;
			yield put(apiResSuccess(response.data.message));
			yield call(getOptionById, id);
			yield call(getOptions);
		} else {
			yield put(apiResError(response.data.message));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

function* updateOption({ payload }: IOptionSavePayload) {
	yield put(apiLoading());
	try {
		const id = payload.id || 0;
		const response: AxiosResponse<SaveRes> =
			yield api.option.apiOptionDataIdPut(id, payload);

		if (response.data.status === SaveStatus.Success) {
			yield put(apiResSuccess(response.data.message));
			yield call(getOptions);
		} else {
			yield put(apiResError(response.data.message));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

function* clearError() {
	yield put(optionClearError());
}

function* resetOptionStore() {
	yield put(optionResetAll());
}

// export function* watchGetOption() {
//     yield takeEvery(GET_OPTION, getOption);
// }

export function* watchGetOptions() {
	yield takeEvery(GET_OPTIONS, getOptions);
}
export function* watchSaveOption() {
	yield takeEvery(SAVE_OPTION, saveOption);
}
export function* watchUpdateOption() {
	yield takeEvery(UPDATE_OPTION, updateOption);
}

export function* watchResetOptionStore() {
	yield takeEvery(OPTION_RESET_ALL, resetOptionStore);
}

export function* watchClearError() {
	yield takeEvery(OPTION_CLEAR_ERROR, clearError);
}

function* optionSaga() {
	yield all([
		// fork(watchGetOption),
		fork(watchGetOptions),
		fork(watchSaveOption),
		fork(watchUpdateOption),
		fork(watchResetOptionStore),
		fork(watchClearError),
	]);
}

export default optionSaga;
